<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="ngx-datatable-shipping">
      <div class="card">
        <div
          class="card-title d-flex justify-content-between align-items-center"
        >
          <h4>Facturas</h4>
          <div>
            <button
              class="btn btn-outline-danger mr-1"
              rippleEffect
              (click)="BatchDelete()"
              [disabled]="selectedBills.length == 0"
            >
              <i data-feather="trash-2" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block">Eliminar en Lote </span>
            </button>
            <button
              class="btn btn-info mr-1"
              rippleEffect
              [routerLink]="['/pages/bash-to-flight']"
            >
              <i data-feather="clipboard" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block">A Vuelo en Lote </span>
            </button>
            <button
              class="btn btn-primary mr-1"
              rippleEffect
              [routerLink]="['/pages/bill-batch-create']"
            >
              <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block">Lote de Facturas</span>
            </button>
            <button
              class="btn btn-primary"
              rippleEffect
              [routerLink]="['/pages/bill-create']"
            >
              <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block">Nueva Factura</span>
            </button>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-12">
              <div
                class="d-flex justify-content-between align-items-center m-1"
              >
                <label class="d-flex align-items-center"
                  >Mostrando
                  <select
                    class="form-control mx-25"
                    [(ngModel)]="basicSelectedOption"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option *ngIf="bills.length > 15" [value]="bills.length">
                      Todos
                    </option>
                  </select>
                  facturas</label
                >
              </div>
            </div>
            <div class="col-md-6 col-12 d-flex justify-content-md-end">
              <div
                class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0"
              >
                <label class="d-flex align-items-center"
                  >Buscar<input
                    #searchInput
                    type="search"
                    placeholder="Código Factura"
                    class="form-control ml-25"
                    (keyup)="FilterUpdate(searchInput.value)"
                    (search)="FilterUpdate(searchInput.value)"
                /></label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-12">
              <ngx-datatable #table ngx-resize-watcher              
              [rows]="bills"
              [rowHeight]="58"
              class="bootstrap core-bootstrap w-100"
              [columnMode]="ColumnMode.force"
              [headerHeight]="40"
              [footerHeight]="50"
              [scrollbarH]="true"
              [limit]="basicSelectedOption"
              [externalSorting]="false"
              [selected]="selected"
            [selectionType]="SelectionType.checkbox"
            (select)="onSelect($event)"            
              [sortType]="'multi'"
              [messages]="{
                emptyMessage: 'No hay información para mostrar',
                totalMessage: 'Total de facturas'
              }"
            >
            <ngx-datatable-column
            [width]="20"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"  
            prop="idCode"                   
          >
            <ng-template
              ngx-datatable-header-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
              name="SMS"
              title="SMS"              
            >
              <input type="checkbox" [checked]="allRowsSelected" (change)="selectFn(!allRowsSelected)" />
            </ng-template>
            <ng-template
              ngx-datatable-cell-template
              let-value="value"             
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
              title="SMS"
              let-idCode="value"
            >
              <input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event, code)" />
            </ng-template>
          </ngx-datatable-column>
              <ngx-datatable-column [width]="150" name="Código" prop="" [comparator]="compareByCode">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <a class="text-wrap" (click)="DownloadPdf(row.id)" target="_self" placement="right"
                  ngbTooltip="Descargar pdf">
                    {{ GetCodeById(row.id) }}</a
                  ><br>
                  {{GetServiceCodeById(row.id)}}
                  
                 
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [width]="110" name="Origen" prop="senderModel">
                <ng-template let-sender="value" ngx-datatable-cell-template>
                  <div
                    placement="left"
                    [ngbTooltip]="'Telefono: ' + sender?.Phone"
                  >
                    <span
                      class="d-inline-block text-truncate"
                      style="max-width: 130px"
                      >{{ sender?.Name | limitText }}</span
                    >
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [width]="115" name="Destino" prop="customerModel">
                <ng-template let-customer="value" ngx-datatable-cell-template>
                  <div
                    placement="left"
                    [ngbTooltip]="'Telefono: ' + customer?.Phone"
                  >
                    <span
                      class="d-inline-block text-truncate"
                      style="max-width: 130px"
                      >{{ customer?.Name | limitText }}</span
                    >
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [width]="70" name="Libras" prop="pounds">
                <ng-template let-pounds="value" ngx-datatable-cell-template>
                  <span>{{ pounds | number: '1.2-2'}}</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [width]="70" name="Total" prop="total">
                <ng-template let-total="value" ngx-datatable-cell-template>
                  <span>{{ total | currency }}</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [width]="75" name="Creada" prop="createAt">
                <ng-template let-createAt="value" ngx-datatable-cell-template>
                  <span>{{ createAt | date : "mediumDate" }}</span>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column [width]="75" name="Estado" prop="stateCatalogName">
                <ng-template let-state="value" ngx-datatable-cell-template>
                  <div class="badge badge-primary mx-1">
                    {{ state }}
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Acciones" [width]="150" [sortable]="false" prop="id">
                <ng-template ngx-datatable-cell-template let-billId="value">
                  <button class="btn btn-outline-light text-primary dropbtn" [ngbPopover]="popoverTemplate" #popOver="ngbPopover"
                    data-container="body" placement="left-top" [autoClose]="'outside'" type="button" id="defaultDropdown"
                    aria-expanded="false">
                    <em class="fa fa-bars"></em>
                  </button>
                  <ng-template #popoverTemplate style="overflow: visible;">
                    <div>
                      <button type="button" ngbTooltip="Asignar a Vuelo" placement="left"
                        class="btn btn-icon btn-outline-success text-success cursor-pointer mr-50" rippleEffect
                        (click)="OpenAssignToFlight(billId)">
                        <span [data-feather]="'clipboard'"></span>
                      </button>
                      <button type="button" ngbTooltip="Editar" placement="left"
                        class="btn btn-icon btn-outline-info text-info cursor-pointer mr-50" rippleEffect
                        [routerLink]="'/pages/bill-create/' + billId">
                        <span [data-feather]="'edit'"></span>
                      </button>
                      <button type="button" ngbTooltip="Eliminar" placement="left"
                        class="btn btn-icon btn-outline-danger text-danger cursor-pointer mr-50" rippleEffect
                        (click)="Delete(billId)">
                        <span [data-feather]="'trash-2'"></span>
                      </button>
                    </div>
                  </ng-template></ng-template>
              </ngx-datatable-column>
              <ngx-datatable-footer *ngIf="true">
                <ng-template
                  ngx-datatable-footer-template
                  let-rowCount="rowCount"
                  let-pageSize="pageSize"
                  let-selectedCount="selectedCount"
                  let-curPage="curPage"
                  let-offset="offset"
                >
                <div class="d-flex justify-content-between w-100">
                  <div class="col-7 col-lg-7 col-sm-7" style="padding: 5px 10px">                
                    <div>Total facturas: {{ rowCount }} | Total libras: {{ totalPounds() | number :'1.2-2' }} | Total cobrado: {{ totalPaid() | currency}}</div>
                  </div>
                  <div class="col-5 col-lg-5 col-sm-5 align-items-center align-self-end text-right text-nowrap">
                      <datatable-pager
                      [pagerLeftArrowIcon]="'datatable-icon-left'"
                      [pagerRightArrowIcon]="'datatable-icon-right'"
                      [pagerPreviousIcon]="'datatable-icon-prev'"
                      [pagerNextIcon]="'datatable-icon-skip'"
                      [page]="curPage"
              [visiblePagesCount]="currentVisible"
              [size]="pageSize"
              [count]="rowCount"
              [hidden]="!((rowCount / pageSize) > 1)"
              (change)="table.onFooterPage($event)">                
                  </datatable-pager>
                    </div>
                </div>
                
                
                  
                  
                </ng-template>
              </ngx-datatable-footer>
            </ngx-datatable>
            </div>
            
          </div>
          
        </div>
      </div>
    </section>
  </div>
</div>
